import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/PcLogin',
    method: 'post',
    data
  })
}

export function getUserDetail() {
  return request({
    url: '/user/getUserDetail',
    method: 'get',
    
  })
}

export function getUserList(params) {
  return request({
    url: '/user/getUserList',
    method: 'get',
    params
  })
}

export function getUserListQ(params) {
  return request({
    url: '/user/getUserListQ',
    method: 'get',
    params
  })
}
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/auth/user-info',
    method: 'get'
  })
} 